import { render, staticRenderFns } from "./GStudentDifferencesTable.vue?vue&type=template&id=56dacacb&scoped=true&"
import script from "./GStudentDifferencesTable.vue?vue&type=script&lang=ts&"
export * from "./GStudentDifferencesTable.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentDifferencesTable.vue?vue&type=style&index=0&id=56dacacb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dacacb",
  null
  
)

export default component.exports